import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "children"],
    _excluded2 = ["className", "name", "image", "subject", "actions", "description", "timestamp", "status", "locale", "attachments", "hasWeekday", "isRelative", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './ActivityTimeline.styles';
import FormatDateTime from '../FormatDateTime';
import Spacer from '../Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var ActivityTimeline = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      mode = _ref.mode,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-activity-timeline"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(Styled.ActivityTimeline, _objectSpread(_objectSpread({
      ref: ref,
      className: className
    }, rest), {}, {
      children: children
    }))
  });
});
var ActivityTimelineItem = forwardRef(function (_ref2, ref) {
  var _cx2, _status$variant, _status$hasLight, _status$isGhost;

  var customClassName = _ref2.className,
      name = _ref2.name,
      image = _ref2.image,
      subject = _ref2.subject,
      actions = _ref2.actions,
      description = _ref2.description,
      timestamp = _ref2.timestamp,
      status = _ref2.status,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? 'en-GB' : _ref2$locale,
      attachments = _ref2.attachments,
      _ref2$hasWeekday = _ref2.hasWeekday,
      hasWeekday = _ref2$hasWeekday === void 0 ? false : _ref2$hasWeekday,
      _ref2$isRelative = _ref2.isRelative,
      isRelative = _ref2$isRelative === void 0 ? false : _ref2$isRelative,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-activity-timeline__item"), true), _defineProperty(_cx2, customClassName, !!customClassName), _cx2));
  return _jsxs(Styled.ActivityTimelineItem, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [_jsxs(Styled.ActivityTimelineItemHeader, {
      children: [_jsx(Styled.ActivityTimelineItemAvatar, {
        name: name,
        src: image
      }), _jsxs(Styled.ActivityTimelineItemInfo, {
        children: [_jsxs(Styled.ActivityTimelineItemMetadata, {
          children: [_jsx(Styled.ActivityTimelineItemMetadataText, {
            isSemibold: true,
            children: name
          }), subject && _jsxs(Styled.ActivityTimelineItemMetadataText, {
            isSecondary: true,
            children: [' ', subject]
          }), status && _jsx(Styled.ActivityTimelineItemStatus, {
            status: (_status$variant = status.variant) !== null && _status$variant !== void 0 ? _status$variant : 'default',
            hasStatusLight: (_status$hasLight = status.hasLight) !== null && _status$hasLight !== void 0 ? _status$hasLight : false,
            isGhost: (_status$isGhost = status.isGhost) !== null && _status$isGhost !== void 0 ? _status$isGhost : false,
            children: status.label
          })]
        }), timestamp && _jsx(Styled.ActivityTimelineItemDate, {
          children: _jsx(FormatDateTime, {
            hasWeekday: hasWeekday,
            value: timestamp,
            locale: locale,
            isRelative: isRelative
          })
        })]
      })]
    }), _jsxs(Styled.ActivityTimelineItemContent, {
      children: [description && _jsx(Styled.ActivityTimelineItemDescription, {
        children: description
      }), attachments && _jsxs(_Fragment, {
        children: [_jsx(Spacer, {
          height: 8,
          axis: "horizontal",
          isBlock: true
        }), _jsx(Styled.ActivityTimelineItemAttachments, {
          children: attachments
        })]
      }), children && _jsxs(_Fragment, {
        children: [_jsx(Spacer, {
          height: 16,
          axis: "horizontal",
          isBlock: true
        }), _jsx(Styled.ActivityTimelineItemComments, {
          children: children
        })]
      })]
    }), actions && _jsx(Styled.ActivityTimelineItemActions, {
      children: actions
    })]
  }));
});
ActivityTimeline.displayName = 'ActivityTimeline';
ActivityTimeline.Item = ActivityTimelineItem;
export default ActivityTimeline;